import { matchAds } from '../utils/adMatcher';
import { cacheGet, cacheSet, CACHE_TTL } from './cache';

/**
 * Ranked + cached ads (5 min). Pass full matchAds ctx including `countryCode` when known.
 * @param {Parameters<typeof matchAds>[0]} ctx
 */
export function getAds(ctx) {
  const regions = Array.isArray(ctx.regions) ? ctx.regions : [];
  const key = `ads:v2:${ctx.type}:${ctx.category || 'all'}:${ctx.language || ''}:${regions.join('|')}:${ctx.countryCode || ''}`;
  const hit = cacheGet(key);
  if (hit) return hit;
  const list = matchAds(ctx);
  cacheSet(key, list, CACHE_TTL.ADS);
  return list;
}

/**
 * @param {Parameters<typeof matchAds>[0]} ctx
 * @param {number} slotIndex
 */
export function pickCachedAd(ctx, slotIndex = 0) {
  const list = getAds(ctx);
  if (!list.length) return null;
  return list[slotIndex % list.length];
}
